import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    marginTop: 137.2,
    marginRight: 15.3,
    marginBottom: 49.9,
    paddingLeft: 16.7,
  },
  buttonStyle: {
    marginTop: 16.7,
    backgroundColor: 'transparent',
  },
  disabledButtonStyle: theme => ({
    backgroundColor: theme.colors.buttons.disabledTwo,
  }),
  disabledTextButtonStyle: theme => ({
    color: theme.colors.tintColor,
  }),
});
